import React from 'react';

class Appointment extends React.Component {
    render() {
        return (
            <section className="appointment">
                <div className="container"><h2 className="appointment__title">Назначение</h2>
                    <div className="appointment__block">
                        <div className="appointment__left"><p className="appointment__about">Автоматизация работы
                            контакт-центра – операторы не участвуют в непосредственном наборе номеров, система
                            самостоятельно переводит на них отвеченные вызовы.</p><p
                            className="appointment__about">Единое управление и хранение всей информации по всем
                            проектам.</p></div>
                        <div className="appointment__right"><p className="appointment__about">Предоставление как
                            оперативной (текущие состояния операторов и линий связи, процент простоя, среднее время на
                            дозвон по контакту и проч.), так и исторической (общее число совершенных вызовов, количество
                            и статусы каждого конкретного контакта и проч.) статистики.</p><p
                            className="appointment__about">Проектная запись разговоров операторов и их последующая
                            выгрузка с использованием произвольных фильтров.</p></div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Appointment;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Appointment.js